import * as fromDatatype from '../datatype-library/index';

export interface bl_pos_terminal_drawer_txn_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  obj_type: fromDatatype.VarcharDatatypeInterface;
  stl_type: fromDatatype.VarcharDatatypeInterface;
  stl_item_code: fromDatatype.VarcharDatatypeInterface;
  session_guid: fromDatatype.GuidDataFieldInterface;
  amount_txn: fromDatatype.NumericDatatypeClass;
  cashier_guid: fromDatatype.GuidDataFieldInterface;
  gendoc_line_guid: fromDatatype.GuidDataFieldInterface;
  amount_balance: fromDatatype.NumericDatatypeClass;
  float_count_hdr_guid: fromDatatype.GuidDataFieldInterface;
  description: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  remarks: fromDatatype.VarcharDatatypeInterface;
  session_name: fromDatatype.VarcharDatatypeInterface;
  cashier_name: fromDatatype.VarcharDatatypeInterface;
  stl_item_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_pos_terminal_drawer_txn_line_RowClass implements bl_pos_terminal_drawer_txn_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  obj_type: fromDatatype.VarcharDatatypeInterface;
  stl_type: fromDatatype.VarcharDatatypeInterface;
  stl_item_code: fromDatatype.VarcharDatatypeInterface;
  session_guid: fromDatatype.GuidDataFieldInterface;
  amount_txn: fromDatatype.NumericDatatypeClass;
  cashier_guid: fromDatatype.GuidDataFieldInterface;
  gendoc_line_guid: fromDatatype.GuidDataFieldInterface;
  amount_balance: fromDatatype.NumericDatatypeClass;
  float_count_hdr_guid: fromDatatype.GuidDataFieldInterface;
  description: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  remarks: fromDatatype.VarcharDatatypeInterface;
  session_name: fromDatatype.VarcharDatatypeInterface;
  cashier_name: fromDatatype.VarcharDatatypeInterface;
  stl_item_guid: fromDatatype.GuidDataFieldInterface;
}
